import { UseBaseQueryOptions, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { UserDetails } from "./user.types";
import axios from "src/utils/axios";
import { api } from "src/config/api.config";
import useUserStore from "./user.store";
import useAuthStore from "../auth/auth.store";

const user = "user";
export const userQueryKeys = {
  root: [user],
  fetchLoggedUser: [user, 'fetchLoggedUser'],
  userDetails: (userId: number): [string, string, number] => [user, 'userDetails', userId],
};

export const useFetchLoggedUser = (config?: UseBaseQueryOptions): UseQueryResult => {
  return useQuery({
    queryKey: userQueryKeys.fetchLoggedUser,
    queryFn: async () => {
      const { data: profile }: AxiosResponse<UserDetails> = await axios.get(api.USER_PROFILE);
      useUserStore.getState().setProfile(profile)
      useAuthStore.getState().login();
      return profile;
    },
    ...config,
  });
};